angular.module('qkr').controller('FormViewController', ['$routeParams', 'formBuilderService', 'appConfig',
    function($routeParams, formBuilderService, appConfig) {
    const self = this;

    const loadSubmissions = function() {
        formBuilderService.listSubmissions($routeParams.formId).then((response) => {
            self.submissions = response.data;

        self.retainUntilDate = self.submissions[0].retainUntilDate;
        for (let i = 1; i < self.submissions.length; i++) {
            if (self.retainUntilDate != self.submissions[i].retainUntilDate) {
                self.retainUntilDate = false;
                break;
            }
        }
        self.setArrow(self.reverse, -2);
    });
    };

    self.setArrow = function(reverse, index, indexedList) {
        self.beneficiaryNameArrow = 'fa fa-sort';
        self.dataPurgeDateArrow = 'fa fa-sort';
        let indexList = [...indexedList];
        angular.forEach(self.submissions[0].formElementValues, (formElement) => {
            formElement.sortArrow = 'fa fa-sort';
        });
        angular.forEach(self.submissions[0].customBeneficiaryFields, (beneficiaryCustomField) => {
            beneficiaryCustomField.sortArrow = 'fa fa-sort';
        });

        if (index >= 0) {
            if (reverse) {
                indexList[index].sortArrow = 'fa fa-sort-up';
            } else {
                indexList[index].sortArrow = 'fa fa-sort-down';
            }
        } else if (index == -1) {
            if (reverse) {
                self.dataPurgeDateArrow = 'fa fa-sort-up';
            } else {
                self.dataPurgeDateArrow = 'fa fa-sort-down';
            }
        } else if (index == -2) {
            if (reverse) {
                self.beneficiaryNameArrow = 'fa fa-sort-up';
            } else {
                self.beneficiaryNameArrow = 'fa fa-sort-down';
            }
        }
    };

    self.toggleSortFormElementValues = function(index) {
        self.reverse = !self.reverse;
        self.sorter = function(submission) {
            self.setArrow(self.reverse, index, submission.formElementValues);
            return submission.formElementValues[index].formElementValue;
        };
    };

    self.toggleSortCustomBeneficiaryFields = function(index) {
        self.reverse = !self.reverse;
        self.sorter = function(submission) {
            self.setArrow(self.reverse, index, submission.customBeneficiaryFields);
            return submission.customBeneficiaryFields[index].fieldValue;
        };
    };

    // Not using for now
    self.export = function() {
        const blob = new Blob([document.getElementById('divTable').innerHTML], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });
        saveAs(blob, 'Report.xls');
    };

    self.selectTable = function() {
        let body = document.body, range, sel;

        const element = document.getElementById('divTable');

        if (document.createRange && window.getSelection) {
            range = document.createRange();
            sel = window.getSelection();
            sel.removeAllRanges();
            try {
                range.selectNodeContents(element);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(element);
                sel.addRange(range);
            }
        } else if (body.createTextRange) {
            range = body.createTextRange();
            range.moveToElementText(element);
            range.select();
        }
    };

    self.exportTable = function() {
        window.location = appConfig.apiUrl + 'form/' + $routeParams.formId + '/exportSubmissions';
    };

    self.getMessagePopover = function() {
        return navigator.appVersion.toLowerCase().indexOf('mac') !== -1 ? 'Press Cmd + C and paste in a spreadsheet' : 'Press Ctrl + C and paste in a spreadsheet';
    };

    loadSubmissions();
}]);



// WEBPACK FOOTER //
// ./src/controllers/formView.controller.js